import type { StylesConfig } from "react-select";

//----------------------------------------------------------------------------//

export const maxWidthPixel = 250;
export const widthViewport = 50;

//----------------------------------------------------------------------------//

export const baseStyles: StylesConfig = {
  singleValue: (defaultStyles) => ({
    ...defaultStyles,
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  }),
  placeholder: (defaultSyles) => ({
    ...defaultSyles,
    color: "#b3b3c2",
  }),
  menuPortal: (defaultSyles) => ({
    ...defaultSyles,
    zIndex: 5,
  }),
};

export const baseControlStyles: StylesConfig = {
  control: (defaultSyles, { isFocused }) => ({
    ...defaultSyles,
    outline: "none",
    boxShadow: "none",
    borderRadius: ".42rem",
    width: `${widthViewport}vw`,
    maxWidth: maxWidthPixel,
  }),
};
